import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Button,
  Card,
  CardHeader,
  Table
} from "reactstrap";
// import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
// import { DateRangePicker } from "react-dates";
// import "react-dates/lib/css/_datepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";

export default class AllStoreOrderSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      isSuperUser: false,
      startDate:moment().endOf("day"),
      endDate:moment().endOf("day"),
      grandTotal:0.0,
      loading:false,
      loadingValue:'Please Wait a moment, loading',
      merchants:null,
      stores:null
    };
  }

  componentDidMount() {
    this.checkLoginMode()
    // this.getConcessionaireStores();
    // this.getOrders();
  }
  getSuperUser = async () => {
    let userInformation = JSON.parse(localStorage.getItem("userInformation"));
    if (userInformation) {
      if (userInformation.isSuperUser) {
        this.setState({ isSuperUser: userInformation.isSuperUser });
      }
    }
  };
  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  handleStartDateChange =(date)=> {
    this.setState({
      startDate: date
    });
  }
  handleEndDateChange =(date)=> {
    if ((Date.parse(this.state.startDate.format("MM/DD/YYYY")) >= Date.parse(date.format("MM/DD/YYYY")))) {
      if((Date.parse(this.state.startDate.format("MM/DD/YYYY")) === Date.parse(date.format("MM/DD/YYYY"))))
      {
        this.setState({
          endDate: date
        });
       
      }else{
        alert("End date should be greater than Start date");
      }
    }else{
  
      this.setState({
        endDate: date
      });
     
    }
  }
  checkLoginMode = () => {
   
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if(loginMode === 'merchant'){
      this.setState({storeInformation:storeInformation,pageText:"Your Order Summary"});
      this.getOrders();
    }else if("concessionaire"){
      // alert(JSON.stringify(storeInformation.concessionaire))
      this.setState({stores: storeInformation.concessionaire});

      this.getOrders1();
    }else{
     
      this.getOrders();
    }

  };
  getConcessionaireStores = async () => {
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getConcessionaireStores"
    );

    if (response.error === null) {
      this.setState({ stores: response.data.stores.edges });
      this.getOrders1();
    }
  };

  getStores = async merchantId => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStores",
      {
        merchantId: merchantId
      }
    );

    if (response.error === null) {
      this.setState({ stores: response.data.merchant.stores.edges });

      if (response.data.stores.edges.length > 0) {
        
          this.getOrders1(response);
        
      }
    }
  };

  getOrders = async () => {
      this.setState({orders:[],grandTotal:0.0,loadingValue: 'Please Wait a moment, loading',loading:false})
      let requestManager = new RequestManager();
      let params = {};

      let date='';
      if (this.state.startDate !== null) {
        date = this.state.startDate.format("YYYY-MM-DDT");
        date = date+"00:00:00+00:00";
        params.createdAt_Gte = date;
      }
      if (this.state.endDate !== null) {
        params.createdAt_Lte = this.state.endDate.format();
      }
      let response = await requestManager.getResponseFromPredefinedQuery(
        "getOrderHistory",
        params
      );

      if (response.error === null) {

          let grandTotal = 0.0;
          for(let i=0; i < response.data.orderHistory.edges.length;i++){
            grandTotal = grandTotal + response.data.orderHistory.edges[i].node.cart.settlementPrice;
          
          }
          // alert(response.data.orderHistory.edges.length)
          if(response.data.orderHistory.edges.length === 0)
            this.setState({ orders: response.data.orderHistory.edges,grandTotal:grandTotal.toFixed(2), loadingValue:'No Rows Found',loading:false});
          else
            this.setState({ orders: response.data.orderHistory.edges,grandTotal:grandTotal.toFixed(2),loading:true});
    
        }
    console.log(response);
  };
  getOrders1 = async () => {
    let orders=[];
    this.setState({orders:[],grandTotal:0.0,loadingValue: 'Please Wait a moment, loading',loading:false})
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let stores = storeInformation.concessionaire;
    
    for(let i=0; i< stores.length; i++){
      let requestManager = new RequestManager();

      let params = {};

      let date='';
      if (this.state.startDate !== null) {
        date = this.state.startDate.format("YYYY-MM-DDT");
        date = date+"00:00:00+05:30";
        params.createdAt_Gte = date;
      }
      if (this.state.endDate !== null) {
        params.createdAt_Lte = this.state.endDate.format();
      }
      params.merchantId = stores[i];
      console.log(params);
      let response = await requestManager.getResponseFromPredefinedQuery(
        "getOrderHistoryACCEPTED",
        params
      );
      console.log(response);
      if (response.error === null) {

          for(let i=0; i < response.data.orderHistory.edges.length;i++){
            // grandTotal = grandTotal + response.data.orderHistory.edges[i].node.cart.settlementPrice;
            orders.push(response.data.orderHistory.edges[i]);

        }

      }
      let grandTotal = 0.0;
      for(let i=0; i < orders.length;i++){
        grandTotal = grandTotal + orders[i].node.cart.settlementPrice;
      }
      if(orders.length === 0)
        this.setState({ orders: orders,grandTotal:grandTotal.toFixed(2), loadingValue:'No Rows Found',loading:false});
      else
        this.setState({ orders: orders,grandTotal:grandTotal.toFixed(2),loading:true});
   
    }
  };
  getCountOfItems = () => {
    if (this.state.orders) {
      let cartItems = this.state.orders && this.state.orders.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };
  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let date='';
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DD");
      // date = date+"00:00:00+00:00";
    }
    let csvData = [
      [
        this.state.pageText,
      ],
      
      [
        "Grand Total",
        "Start Date",
        "End Date",
        
      ],
      [
        this.state.grandTotal,
        date,
        this.state.endDate.format("YYYY-MM-DD")
      ],
      [
        "",
      ],
      [
        "",
      ],
      [
        "Order Id",
        "Token",
        "Status",
        "Date/Time",
        "SubTotal(₹)",
        "Discount(₹)",
        "Tax Amount(₹)",
        "Total Amount(₹)",
        "Store"
      ]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt).utcOffset("+05:30").format("MMMM DD YYYY, h:mm a"),
        order.node.cart.subtotal,
        this.getDiscountAmount(order.node.cart.settlementExtra),
        this.getGSTAndCGST(order.node.cart.settlementExtra),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name
      ]);
    });
    return csvData;
  };

  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        
        <Row noGutters>
          <Col xs="12">
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>Store orders</h5>
                    </Col>
                  
                  </Row>
                    <Col xs="12" sm="12" md="8" lg="8">
                      <div
                        style={{
                          display: "flex",
                          margin:20,
                        }}
                      >
                        <DatePicker
                        selected={this.state.startDate}
                        maxDate={moment().endOf("day")}
                        dateFormat="DD/MM/YYYY"
                      
                        onChange={this.handleStartDateChange}
                        />
                        <div style = {{marginLeft:15}}>
                          <DatePicker
                            
                            selected={this.state.endDate}
                            dateFormat="DD/MM/YYYY"
                            maxDate={moment().endOf("day")}
                            onChange={this.handleEndDateChange}
                          />
                        </div>
                        
                        <Button style={{marginLeft:20,backgroundColor:'#00a9db',color:'white'}} onClick = { 
                          
                          this.getConcessionaireStores}>Submit</Button>
                      {
                        // <DateRangePicker
                        //   startDate={this.state.startDate}
                        //   startDateId={"unique_start_date_id"}
                        //   endDate={this.state.endDate}
                        //   endDateId={"unique_start_date_id"}
                        //   focusedInput={this.state.focusedDate}
                        //   displayFormat="DD[/]MM[/]YYYY"
                        //   isOutsideRange={day => {
                        //     return moment().endOf("day") <= day;
                        //   }}
                        //   onDatesChange={({ startDate, endDate }) => {
                        //     if (endDate != null) {
                        //       this.setState(
                        //         {
                        //           startDate: startDate.startOf("day"),
                        //           endDate: endDate.endOf("day"),
                        //           orders: []
                        //         },
                        //         () => {
                        //           this.getOrders();
                        //         }
                        //       );
                        //     }
                        //   }}
                        //   onFocusChange={focusedDate =>
                        //     this.setState({ focusedDate: focusedDate })
                        //   }
                        //   orientation="vertical"
                        // />
                        }
                       
                          <CSVLink
                            className="btn btn-primary"
                            style={{ marginLeft: 40 }}
                            filename={"Orders.csv"}
                            data={this.getCSVData()}
                          >
                            Export to CSV
                          </CSVLink>
                        
                      </div>
                    </Col>
                    <Row>
                      <h5 style={{marginLeft:20,textAlign:'center',justifyContent:'center'}}>{ 'Number of orders#' +this.state.orders.length}</h5>
                      <h5 style={{marginLeft:20,textAlign:'center',justifyContent:'center'}}>{ 'Grand Total= ' +this.state.grandTotal}</h5>
                    </Row>
                </Container>
              </CardHeader>
              <Table responsive>
                <tbody>
                  <tr>
                    <th>Order Id</th>
                    <th>Token</th>
                    <th>Status</th>
                    <th>Date/Time</th>
                    <th>SubTotal</th>
                    <th>DiscountAmount</th>
                    <th>TaxAmount</th>
                    <th>Total Amount</th>
                    <th>Store</th>
                  </tr>
                  {
                    this.state.loading === false ?
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td style={{textAlign:'center'}}>{this.state.loadingValue}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  :
                    this.state.orders && this.state.orders.map(order => {
                      return (
                        <tr
                          key={order.node.id}
                          onClick={() => {
                            this.setState({ selectedOrder: order });
                            // this.toggleModal();
                          }}
                        >
                          <td>{order.node.orderId}</td>
                          <td>{order.node.storeToken}</td>
                          <td>{order.node.status}</td>
                          <td>
                              {moment(order.node.createdAt).utcOffset("+05:30").format(
                              "MMMM DD YYYY, h:mm a"
                              )}
                          </td>
                          <td>{"₹" + order.node.cart.subtotal}</td>
                          <td> {"₹" +order.node.cart.settlementExtra && this.getDiscountAmount(order.node.cart.settlementExtra)}</td>
                          <td> {"₹" + order.node.cart.settlementExtra && this.getGSTAndCGST(order.node.cart.settlementExtra)}</td>
                          <td>{"₹" + order.node.cart.settlementPrice}</td>
                          <td>{order.node.cart.pickupPoint.store.name}</td>
                        </tr>
                      );
                    })
                }
                
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
  getGSTAndCGST =(extraText)=>{
    let gst_cgst=0;
    try{
    let extra = JSON.parse(extraText);
    // eslint-disable-next-line
    let offers = extra.offer === null ? [] : extra.offer;
    let charges = extra.charge === null ? [] : extra.charge;
    
    for(let i=0 ; i< charges.length; i++){
      gst_cgst = gst_cgst +charges[i].amount;
    }
    }
    catch(e){
      gst_cgst =0
    }
    return gst_cgst;
    
  }
  getDiscountAmount =(extraText)=>{
    let offersAmount=0;
    try{
    let extra = JSON.parse(extraText);
   
    
    let offers = extra.offer === null ? [] : extra.offer;

    for(let i=0 ; i< offers.length; i++){
      offersAmount = offersAmount +offers[i].amount;
    }
    
    }
    catch(e){
      offersAmount = 0
    }
    return offersAmount;
  }
}



// WEBPACK FOOTER //
// ./src/pages/AllStoreOrderSummary/AllStoreOrderSummary.js